/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_TaglineInputs */

const en_directory_submit_tagline = /** @type {(inputs: Directory_Submit_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short description`)
};

const zh_directory_submit_tagline = /** @type {(inputs: Directory_Submit_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简短描述`)
};

/**
* | output |
* | --- |
* | "Short description" |
*
* @param {Directory_Submit_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_tagline = /** @type {((inputs?: Directory_Submit_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_tagline(inputs)
	return zh_directory_submit_tagline(inputs)
});
export { directory_submit_tagline as "directory.submit.tagline" }